import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import DashboardLayout from '@/components/layout/DashboardLayout';

export default function SubscriptionDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: sub } = useQuery({
    queryKey: ['admin-subscription', id],
    queryFn: async () => {
      if (!id) return null;
      const { data } = await supabase
        .from('posit_subscriptions')
        .select('id, user_id, status, price_id, created_at, updated_at')
        .eq('id', id)
        .maybeSingle();
      return data as any;
    },
    enabled: !!id,
  });

  return (
    <DashboardLayout title="Subscription" maxWidth="4xl" headerActions={<Button variant="outline" onClick={() => navigate('/admin/business/subscriptions')}>Back</Button>}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-4 border rounded-lg">
            <div className="text-sm text-muted-foreground">ID</div>
            <div className="font-mono text-xs">{sub?.id || '—'}</div>
          </div>
          <div className="p-4 border rounded-lg">
            <div className="text-sm text-muted-foreground">User</div>
            <div className="font-mono text-xs">{sub?.user_id || '—'}</div>
          </div>
          <div className="p-4 border rounded-lg">
            <div className="text-sm text-muted-foreground">Status</div>
            <div className="font-medium">{sub?.status || '—'}</div>
          </div>
          <div className="p-4 border rounded-lg">
            <div className="text-sm text-muted-foreground">Price</div>
            <div className="font-mono text-xs">{sub?.price_id || '—'}</div>
          </div>
          <div className="p-4 border rounded-lg">
            <div className="text-sm text-muted-foreground">Created</div>
            <div className="font-medium">{sub?.created_at ? new Date(sub.created_at).toLocaleString() : '—'}</div>
          </div>
          <div className="p-4 border rounded-lg">
            <div className="text-sm text-muted-foreground">Updated</div>
            <div className="font-medium">{sub?.updated_at ? new Date(sub.updated_at).toLocaleString() : '—'}</div>
          </div>
        </div>
    </DashboardLayout>
  );
}


